import React from 'react'
import { Typography, Grid, Grow, Tooltip, Rating } from '@mui/material';
import { Link } from 'react-router-dom';
import useStyles from './Styles';
const Movie = ({ movie, i }) => {
  const classes = useStyles();
  return (
    <div>
          {/* <Grid item xs={12} sm={6} md={2} lg={4} xl={2} className={classes.movie}> */}
        {/* <Grow in key={i} timeout={1000}> */}
        <div className="" style={{display:"flex",justifyContent:"center", alignItems:"center"}}>
        <Link className={classes.links} to={`/movie/${movie.id}`}>
          <img
            src={movie.poster_path ? `https://image.tmdb.org/t/p/w500/${movie.poster_path}` : 'https://image.tmdb.org/t/p/w500/kAVRgw7GgK1CfYEJq8ME6EvRIgU.jpg'}
            alt={movie.title}
            className={classes.image}
          />
          <Typography className={classes.title} variant="h5">{movie.title}</Typography>
          <Tooltip disableTouchListener title={`${movie.vote_average} / 10`}>
            <div>
              <Rating readOnly value={movie.vote_average / 2} precision={0.1} />
            </div>
          </Tooltip>
          </Link>
          </div>
      {/* </Grow> */}
    {/* </Grid> */}
    </div>
  )
}

export default Movie